export enum AuthenticationClientType {
  Unauthorized = 0,
  Microsoft = 1,
  Google = 2,
}
